import cvi from './cvi';
import dataviz from './dataviz';

export default {
  // Primitives
  cvi,
  dataviz,
  // DO NOT USE THIS DIRECTLY: This is needed for all components using variant="primary"
  primary: {
    main: cvi.primary[30],
    dark: cvi.primary[30],
    light: cvi.green[30],
    contrastText: cvi.neutrals[10],
  },
  // Initial proposal of design tokens for color palette.
  background: {
    default: cvi.neutrals[10],
    main: cvi.neutrals[10],
    brand: cvi.primary[30],
    inactive: cvi.neutrals[40],
    dark: cvi.neutrals[80],
    hover: cvi.neutrals[20],
    error: cvi.red[10],
  },
  field: {
    main: cvi.neutrals[10],
    success: cvi.green[30],
    error: cvi.red[40],
    disabled: cvi.neutrals[20],
    border: cvi.neutrals[80],
  },
  border: {
    subtle: cvi.neutrals[40],
    disabled: cvi.neutrals[30],
    divider: cvi.neutrals[30],
    hover: cvi.primary[30],
    beige: cvi.beige[40],
    error: cvi.red[30],
  },
  text: {
    primary: cvi.neutrals[80],
    secondary: cvi.primary[30],
    disabled: cvi.neutrals[60],
    description: cvi.neutrals[60],
    onPrimary: cvi.neutrals[10],
    description2: cvi.neutrals[70],
    error: cvi.red[40],
  },
  link: {
    primary: cvi.primary[30],
    secondary: cvi.neutrals[70],
  },
  button: {
    primary: cvi.primary[30],
    primaryHover: cvi.primary[20],
    primaryActive: cvi.primary[40],

    ghostPrimary: cvi.neutrals[70],
    ghostHover: cvi.neutrals[60],
    ghostActive: cvi.neutrals[80],

    dangerPrimary: cvi.red[40],
    dangerHover: cvi.red[30],
    dangerActive: cvi.red[50],

    disabled: cvi.neutrals[20],

    feedbackBorder: cvi.neutrals[40],

    secondaryPrimary: cvi.neutrals[10],

    snackbarAction: cvi.green[30],
  },
  support: {
    error: cvi.red[40],
    success: cvi.green[30],
    warning: cvi.yellow[40],
    info: cvi.blue[40],
  },
  icon: {
    primary: cvi.neutrals[80],
    ghost: cvi.neutrals[70],
    secondary: cvi.neutrals[60],
    background: cvi.beige[40],
  },
  misc: {
    highlight: {
      background: cvi.blue[10],
      border: cvi.blue[30],
      text: cvi.blue[50],
    },
    scrollBar: {
      border: cvi.neutrals[10],
    },
    progressSpinner: {
      primary: cvi.primary[30],
      secondary: cvi.neutrals[60],
    },
    beigeBackground: cvi.beige[20],
  },
};
